import { render, staticRenderFns } from "./recordsDetailsDialog.vue?vue&type=template&id=b82c6572&scoped=true"
import script from "./recordsDetailsDialog.vue?vue&type=script&lang=js"
export * from "./recordsDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./recordsDetailsDialog.vue?vue&type=style&index=0&id=b82c6572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c6572",
  null
  
)

export default component.exports